// Corporate Growth Sessions - Adapted for corporate users with corporate user data
import React from 'react';
import GrowthSessionManagement from '../../GrowthSessions/GrowthSessionManagement';

/**
 * Corporate Growth Sessions Component
 * Uses corporate user data when REACT_APP_CORPORATE_MODE is enabled
 */
const CorporateGrowthSessionManagement = () => {
    // For now, uses the standard component
    // Can be customized to use corporate-specific queries and data
    return <GrowthSessionManagement />;
};

export { CorporateGrowthSessionManagement as GrowthSessionManagement };
